import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface ButtonConfig {
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'outline' | 'outline-secondary';
  size?: 'sm' | 'md' | 'lg';
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  loading?: boolean;
  icon?: string;
  iconPosition?: 'left' | 'right';
  fullWidth?: boolean;
  rounded?: boolean;
}

@Component({
  selector: 'app-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
})
export class ButtonComponent {
  config = input<ButtonConfig>({});
  buttonClick = output<Event>();

  buttonClasses = computed(() => {
    const config = this.config();
    const classes = ['btn'];

    if (config.variant) {
      classes.push(`btn-${config.variant}`);
    }

    const size = config.size || 'md';
    classes.push(`btn-${size}`);

    if (config.fullWidth) {
      classes.push('btn-full-width');
    }

    if (config.rounded) {
      classes.push('btn-rounded');
    }

    return classes.join(' ');
  });

  onClick(): void {
    if (!this.config().disabled && !this.config().loading) {
      this.buttonClick.emit(new Event('click'));
    }
  }
}
